<template>
    <LayoutForm>
        <div class="sector-edit">
            <h1>Add Sector</h1>
            <div class="sector-edit__wrapper">
                <form class="form" @submit.prevent="submit" novalidate>
                    <ValidationAlert :error-list="errors"></ValidationAlert>

                    <FormControlSector
                        label="Parent Sector (if applicable)"
                        name="sectors"
                        v-model="formData.parent_sector"
                        :multiple="false"
                        :include-ancestors="false"
                    />

                    <div class="sector-edit__new">
                        <div class="form__group">
                            <input id="name" name="name" class="form__control" v-model="formData.title" @input="slugify_field(formData.title)"
                            placeholder="Enter a new name for this sector..." v-validate required />
                            <label for="name" class="form__label">Name</label>
                            <div class="form__validation"></div>
                        </div>
                        <div class="form__group">
                            <input id="slug" name="slug" class="form__control" v-model="formData.slug"
                            placeholder="Enter a new slug for this sector..." v-validate required />
                            <label for="slug" class="form__label">Slug</label>
                            <div class="form__validation"></div>
                        </div>
                        <FileUpload
                            id="image"
                            label="Image"
                            v-model="formData.image"
                            name="image"
                            :multiple="false"
                        />
                        <FormControlUser
                            name="leader"
                            v-model="formData.leader_id"
                            label="Select Sector Leader"
                        />
                        <div class="form__group">
                            <div class="checkbox">
                                <input id="public" type="checkbox" v-model="formData.public" />
                                <label for="public">Shown publicly on sector page?</label>
                            </div>
                        </div>
                        <div class="form__group form__group--submit">
                            <button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </LayoutForm>
</template>

<script>
import FilterableList from '../List/FilterableList'
import FormControlSector from '../Form/Control/FormControlSector';
import LayoutForm from '../Layout/LayoutForm';
import API from '../../api';
import ValidationAlert from '../ValidationAlert';
import slugify from 'slugify';
import FileUpload from '@components/Form/FileUpload.vue';
import FormControlUser from '@components/Form/Control/FormControlUser.vue';

//TODO: Ensure only admins can see this component.
export default {
    name: "SectorEdit",
    mixins: [FilterableList, ValidationAlert],
    components: {
        FormControlUser,
        FileUpload,
        FormControlSector, ValidationAlert, LayoutForm},
    data() {
        return {
            sector_list: this.sectors || [],
            displayed: false,

            //where the data from the forms is sent to.
            formData: {
                parent_sector: null,
                title: null,
                slug: null,
                image: null,
                leader_id: null,
                public: true,
            },
            errors: []
        }
    },
    methods: {
        load() {
            //if no sectors are set, load them in from the API.
            if(!this.sectors) {
                this.loading = true;

                API.getSectors().then(response => {
                    this.loaded = true;
                    this.sector_list = response;
                    // console.log("Retrieved sectors: ", this.sector_list);
                }).catch(() => {
                    this.error = true;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

        submit(e) {
            this.errors = [];

            if(this.formData.title === null || this.formData.title === '') {
                this.errors.push("Title is required")
            }
            if(this.formData.slug === null || this.formData.slug === '') {
                this.errors.push("Slug is required.")
            }

            //if we have no errors publish the
            if(this.errors.length === 0) {
                this.formData.slug = slugify(this.formData.slug).toLowerCase();

                API.createSector(this.formData).then((res) => {
                    console.log("Recieved response: ", res);
                    this.$router.push('/sectors');
                })
                .catch(error => {
                    API.mapServerValidation(error.response, this.$validator);
                });
            }

            // console.log(this.errors);
        },

        slugify_field(text) {
            this.formData.slug = slugify(text).toLowerCase();
        }
    },
    created() {
        this.load();
    }
}
</script>

<style lang="scss" scoped>
    @import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';
</style>

